import React, { useEffect, useState, useCallback, useMemo, useRef } from "react"
import { AgGridReact } from "ag-grid-react"
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import downloadIcon from '../../assets/downloadIcon.png'
import { Info } from "react-feather";

const MergedTurnoverTable = (props) => {

  const gridRef = useRef()
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

  // const rowData = props.data

  const data = props.firstTimeData
  const data2 = props.engagedData

  const [rowData, setRowData] = useState([]);
  const [resourseNames, setResourseNames] = useState([]);
  const [mergedData, setMergedData] = useState([]);

  useEffect(() => {
    const countMap = {};

    // Update countMap with counts from data
    if (data) {
      data.forEach(item => {
        countMap[item.resource_name] = {
          first_time_count: item.resource_count,
          engaged_count: 0
        };
      });
    }

    // Update countMap with counts from data2 or set engaged_count to 0 if not found
    if (data2) {
      data2.forEach(item => {
        if (countMap[item.resource_name]) {
          countMap[item.resource_name].engaged_count = item.resource_count;
        } else {
          countMap[item.resource_name] = {
            first_time_count: 0,
            engaged_count: item.resource_count
          };
        }
      });
    }

    // Convert countMap back to an array
    const mergedData = Object.keys(countMap).map(resource_name => ({
      resource_name: resource_name,
      first_time_count: countMap[resource_name].first_time_count,
      engaged_count: countMap[resource_name].engaged_count
    }));

    const resNames = mergedData.map(data => data.resource_name);
    console.log("Res Name", resNames);
    setResourseNames(resNames);

    setRowData(mergedData);
    setMergedData(mergedData);
  }, [data, data2]);

  const footerRow = {
    resource_name: "Total",
    first_time_count: "Total" + " : " + " " + rowData.reduce((total, row) => total + row.first_time_count, 0),
    engaged_count: "Total" + " : " + " " + rowData.reduce((total, row) => total + row.engaged_count, 0),
  };

  const [columnDefs, setColumnDefs] = useState([
    {
      field: "resource_name",
      headerName: "Annual Turnover",
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", width: '100%', alignItems: "center" }}>
            <div>{params.displayName}</div>
          </div>
        );
      },
      cellRenderer: params => {
        let resourceName = params.value;
        if (resourceName === "null") {
          resourceName = "Not Provided";
        }
        if (resourceName === "Total") {
          return <div style={{ textAlign: "right", display: 'none' }}>{resourceName}</div>;
        } else {
          return resourceName;
        }
      },
      width: 450,
    },
    {
      field: "first_time_count",
      headerName: "No of First Time Users",
      // width: 205,
      flex: 1,
      sortable: true,
      pinnedBottomRowCellRenderer: "agGroupCellRenderer",
      cellStyle: { textAlign: "right" },
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", justifyContent: 'flex-end', width: '100%', alignItems: "center" }}>
            <div>{params.displayName}</div>
          </div>
        );
      },
    },
    {
      field: "engaged_count",
      headerName: "No of Engaged Users",
      // width: 280,
      flex: 1,
      sortable: true,
      pinnedBottomRowCellRenderer: "agGroupCellRenderer",
      cellStyle: { textAlign: "right" },
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", justifyContent: 'flex-end', width: '100%', alignItems: "center" }}>
            <div>{params.displayName}</div>
          </div>
        );
      },
    },
  ]);

  const gridOptions = useMemo(() => ({
    suppressScrollOnNewData: true,
  }), []);

  const handleDownloadCSV = () => {
    const csvData = [];
    csvData.push('Annual Turnover, No of First Time Users, No of Engaged Users'); // CSV header

    rowData.forEach(row => {
      csvData.push(`${row.resource_name}, ${row.first_time_count}, ${row.engaged_count}`);
    });

    const csvBlob = new Blob([csvData.join('\n')], { type: 'text/csv' });
    const csvUrl = window.URL.createObjectURL(csvBlob);

    const downloadLink = document.createElement('a');
    downloadLink.href = csvUrl;
    downloadLink.download = 'annual_turnover_data.csv';
    downloadLink.style.display = 'none';
    document.body.appendChild(downloadLink);
    downloadLink.click();

    window.URL.revokeObjectURL(csvUrl);
    document.body.removeChild(downloadLink);
  };


  return (
    <div>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        // justifyContent: 'center',
        margin: 10
      }}>
        <h3 className="spled-colored-label" style={{
          fontSize: "20px",
          textAlign: 'center',
          marginRight: 10
        }}>6. First time and Engaged Users based on Annual Turnover</h3>
        <span style={{ cursor: "pointer" }} title="Display of First time users and engaged users based on Annual Turnover">
          <Info style={{ width: "15px", marginRight: "10px", marginBottom:"5px" }} />
        </span>
        {
          rowData.length > 0 && (
            // <Button className="esp-inline-button"
            //   onClick={handleDownloadCSV}
            // >Download CSV</Button>
            <img src={downloadIcon} title="Download CSV" alt="" onClick={handleDownloadCSV} style={{
              cursor: "pointer"
            }} />
          )
        }
      </div>

      <div style={{
        height: "50vh",
      }}>
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <div style={gridStyle} className="ag-theme-material">
            <AgGridReact ref={gridRef}
              rowData={rowData}
              columnDefs={columnDefs}
              pinnedBottomRowData={[footerRow]}
              gridOptions={gridOptions}
              overlayNoRowsTemplate={
                '<span class="ag-overlay-loading-center">loading...</span>'
              }
              rowClassRules={{
                'total-row': 'data.resource_name === "Total"'
              }}
            >
            </AgGridReact>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MergedTurnoverTable
